export default __webpack_public_path__ + "static/media/17.78e31b28.wav";